import SeriesList from './SeriesList'

export default SeriesList
